export const SEARCH_LIMIT = 8
export const SITES = {
  CORONAVIRUS: 'covid-19',
  WELLBEING: 'mywellbeing',
  RETAILCOMMS: 'retailcomms',
}
